import script from "./RoomCarouselComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomCarouselComponent.vue?vue&type=script&setup=true&lang=js"

import "./RoomCarouselComponent.vue?vue&type=style&index=0&id=bcfe022a&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcfe022a"]])

export default __exports__